module.exports = __webpack_public_path__ + "img/img35.8c7580a0.svg";